import { render, staticRenderFns } from "./RegistrationACSStatusReport.vue?vue&type=template&id=54bfbae4"
import script from "./RegistrationACSStatusReport.vue?vue&type=script&lang=js"
export * from "./RegistrationACSStatusReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports